angular.
module("digiexam.components").
directive("lastOfflineDownload", function lastOfflineDownloadDirective() {
	"use strict";

	return {
		restrict: "A",
		scope: {exam: "="},

		link: function link($scope, element) {
			element.attr("rel", "tooltip");

			function setTooltip() {
				var title = $scope.getString("DownloadOfflineFile");
				if ($scope.exam.lastOfflineDownload !== "0001-01-01T00:00:00Z") {
					title = $scope.getString("LatestDownload") + " " + $scope.getDate($scope.exam.lastOfflineDownload);
				}
				return element.attr("data-original-title", title);
			}

			$scope.$watch("exam", function watcher() {
				if (typeof $scope.exam === "undefined") {
					return;
				}

				setTooltip();
			});

			return element.on("click", function onClick() {
				return $scope.$apply(function updateDate() {
					$scope.exam.lastOfflineDownload = new Date();
					setTooltip();
				});
			});
		},

		controller: function controller($scope, $filter, dxLocalize) {
			$scope.getString = function getString(s) {
				return dxLocalize.get(s);
			};

			$scope.getDate = function getDate(date) {
				return $filter("date")(date, "yyyy-MM-dd HH:mm:ss");
			};
		},
	};
});
